import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { GetMaxDecimalWithStaticMinValidation, Required } from '../../../../../../lib/validation/ValidationTypes';
import { mapindexbyPath } from '../../../../../../utils/formStruc';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import { get } from 'lodash';
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;

const Projektergebnisse: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Beschreibung der bislang erreichten Projektergebnisse' description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStrucProjektergebnisse} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default Projektergebnisse;

export const formStrucProjektergebnisse: FormStrucItem[] = [
	{
		fields: [{ ...P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1, type: 'componentTable' }],
		userProps: { columnToDivide: 1 },
	},
];

const customformStruc = (): FormStrucItem[] => [
	{
		fields: [
			P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.schema.attributes.Zelle_1,
			P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.schema.attributes.Zelle_2,
			P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.schema.attributes.Zelle_3,
			P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.schema.attributes.Zelle_4,
			P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.schema.attributes.Zelle_5,
			{
				...P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.schema.attributes.Zelle_6,
				validation: [{ validateFunction: Required }, { validateFunction: GetMaxDecimalWithStaticMinValidation, params: [100] }],
			},
		],
	},
];

export function getFormStrucProjektergebnisse(application: any) {
	let result: any = [];
	const componentTableLength = get(application, P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1.path, []).length;
	const parentObject = P.Beschreibung_Der_Bislang_0007066993_se_Projektergebnisse_Block_1;

	for (let i = 0; i < componentTableLength; i++) {
		mapindexbyPath(customformStruc(), i, parentObject).forEach((element: any) => {
			result.push(element);
		});
	}

	return result;
}
